var React = require('react');

function DownloadArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.0001 14.5043C6.19506 14.496 6.42093 14.4065 6.56261 14.2592L11.7445 8.82981C12.0844 8.51285 12.0769 7.90253 11.7712 7.54669C11.4654 7.19085 10.9231 7.16142 10.6195 7.51959L6.81815 11.4975L6.81815 1.53429C6.81815 1.03473 6.45165 0.629394 5.99995 0.629394C5.54826 0.629394 5.18176 1.03473 5.18176 1.53429L5.18176 11.4975L1.38042 7.51959C1.07679 7.1614 0.532387 7.18966 0.226627 7.54669C-0.0791324 7.9037 -0.0812601 8.52111 0.255392 8.8298L5.4373 14.2592C5.59604 14.4242 5.78141 14.5019 5.99981 14.5043L6.0001 14.5043Z"}));
}

DownloadArrowIcon.defaultProps = {"width":"12","height":"15","viewBox":"0 0 12 15"};

module.exports = DownloadArrowIcon;

DownloadArrowIcon.default = DownloadArrowIcon;
